import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import styled from "styled-components";
import axios from "axios";
import Constant from "./Constant";
import $ from "jquery";
import { getProfileDetails, updateUserProfile } from "./utilities/ApiCalls";
import { PencilIcon } from "lucide-react";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { toast } from "sonner";
import ProfileImage from "../Componets/ProfileImage";

export const EditProfile = () => {
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);

  const [profile, setprofile] = useState();

  const [updateForm, setUpdateForm] = useState({
    name: "",
    userName: "",
    email: "",
    dob: "",
    mobile: "",
    gender: "",
    countryId: "",
    stateId: "",
    cityId: "",
    profilePic: "",
    intro: "",
  });
  useEffect(() => {
    getProfile();
  }, []);

  useEffect(() => {
    if (profile) {
      setUpdateForm({
        name: profile.name || "",
        userName: profile.userName || "",
        email: profile.email || "",
        dob: profile.dob || "",
        mobile: profile.mobile || "",
        gender: profile.gender || "",
        countryId: profile.countryId || "",
        stateId: profile.stateId || "",
        cityId: profile.cityId || "",
        profilePic: profile.profilePic || "",
        intro: profile.intro || "",
      });
    }
  }, [profile]);

  // console.log(profile);
  // console.log(updateForm);

  const getProfile = () => {
    getProfileDetails().then((response) => {
      setprofile(response.data.data);
    });
  };

  function handleFormChange(e) {
    if (e.target.name === "mobile" && e.target.value.length > 10) {
      toast("mobile number shjould be of 10 digit!");
      return;
    }
    // console.log(e.target.name);

    setUpdateForm({
      ...updateForm,
      [e.target.name]: e.target.value,
    });
  }

  function handleFormSubmit(e) {
    e.preventDefault();
    const payload = {
      ...updateForm,
      userId: profile?._id,
    };
    updateUserProfile(payload).then((response) => {
      if (response.status === Constant.statusSuccess) {
        toast.success("Profile updated successfully!");
        setTimeout(() => window.location.reload(), 1500);
      } else {
        toast.error(response.message || "Failed to update profile");
      }
    }).catch((err) => {
      toast.error(err?.response?.data?.message || "Failed to update profile");
    });
  }

  function changeProfilePicture(event) {
    try {
      let token = localStorage.getItem("loginDetails");
      let image = event.target.files[0];
      const form_data = new FormData();

      let extension = image.name.split(".").pop();
      if (
        extension !== "jpg" &&
        extension !== "png" &&
        extension !== "JPG" &&
        extension !== "PNG"
      ) {
        $("#error-msg").text("Only jpg and png file type are allow!");
        // $("#error-msg").css("color", "red");
        return false;
      }

      form_data.append("userProfile", image, image.name);

      axios
        .post(Constant.apiBasePath + "user/updateProfilePic", form_data, {
          headers: { token: token },
        })
        .then((response) => {
          const getResults = response.data.message;

          if (response.data.status === Constant.statusSuccess) {
            $("#success-msg").text("Your profile pic uploaded successfully.");
            setTimeout(function () {
              window.location.reload();
            }, 3000);
          } else {
            $("#error-msg").text(getResults);
          }
        });
    } catch (err) {
      // console.log(err);
    }
  }

  const proxiedUrl = (url) => {
    if (!url || url.includes("story-tent-testing.s3.ap-south-1.amazonaws.com"))
      return url;
    return `${Constant.apiBasePath}proxy-image?url=${encodeURIComponent(url)}`;
  };

  return (
    <Layout>
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Root>
          {profile && (
            <div className="profile-wrapper">
              <div className="profile-image-container">
                <ProfileImage
                  src={profile?.profilePic}
                  name={profile?.name}
                  size={100}
                  className="profile-img"
                  alt="profile"
                  proxiedUrl={proxiedUrl}
                  avatarProps={{
                    className: "profile-img-default",
                  }}
                />
                <div onClick={changeProfilePicture} className="edit">
                  <PencilIcon></PencilIcon>
                </div>
                <input
                  id="file-input"
                  className="profile-img-input"
                  type="file"
                  onChange={changeProfilePicture}
                  accept="image/png, image/jpg"
                />
              </div>

              <form onChange={handleFormChange} className="form">
                <div className="content">
                  <label className="label">Username</label>
                  <input
                    name="userName"
                    value={updateForm.userName}
                    onChange={(e) => {
                      setUpdateForm({
                        ...updateForm,
                        userName: e.target.value,
                      });
                    }}
                    className="input"
                    placeholder="Enter username"
                  />
                </div>
                <div className="content">
                  <label className="label">Bio</label>
                  <textarea
                    name="intro"
                    className="input"
                    style={{ minHeight: "60px" }}
                    value={updateForm.intro}
                    onChange={handleFormChange}
                  ></textarea>
                </div>
                <div className="content">
                  <label className="label">DOB</label>
                  <input
                    type="date"
                    name="dob"
                    value={updateForm.dob}
                    onChange={handleFormChange}
                    className="input"
                    placeholder="dd-mm-yyyy"
                  />
                </div>
                <div className="content">
                  <label className="label">Contact Number</label>
                  <input
                    name="mobile"
                    value={updateForm.mobile || ""}
                    onChange={handleFormChange}
                    className="input"
                  />
                </div>
                <div className="content">
                  <label className="label">Email Id</label>
                  <input
                    name="email"
                    value={updateForm.email}
                    onChange={handleFormChange}
                    className="input disabled"
                    disabled
                    title="Contact support to change your email address."
                  />
                  <span className="helper-text">
                    Contact support to change your email address.
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    type="submit"
                    onClick={handleFormSubmit}
                    className="btn"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          )}
        </Root>
      </div>
    </Layout>
  );
};

const Root = styled.div`
  min-height: 100vh;
  height: auto;
  display: flex;
  width: 100%;
  max-width: 100vw;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;

  .profile-wrapper {
    width: 100%;
    max-width: 680px;
    margin: 40px auto;
    background: transparent;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }

  .form {
    margin-top: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .btn {
    width: 120px;
    height: 44px;
    background-color: var(--color-primary);
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    margin-top: 24px;
    color: var(--color-surface);
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }

  .input {
    width: 100%;
    background-color: var(--color-surface);
    border: 1px solid var(--color-border);
    outline: none;
    padding: 10px 14px;
    border-radius: 4px;
    display: block;
    color: var(--color-text);
    font-size: 14px;
    margin-top: 6px;
    box-sizing: border-box;
    resize: none;

    &:focus {
      border-color: var(--color-text);
    }

    &.disabled {
      background-color: var(--color-surface);
      color: var(--color-text-secondary);
      opacity: 0.7;
      cursor: not-allowed;
    }
  }

  .helper-text {
    font-size: 12px;
    color: var(--color-text-tertiary);
    margin-top: 4px;
  }

  textarea.input {
    min-height: 80px;
    max-height: 200px;
    font-family: inherit;
  }

  .label {
    color: var(--color-text-tertiary);
    margin-left: 0;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .profile-image-container {
    height: 100px;
    width: 100px;
    border-radius: 50%;
    margin-bottom: 24px;
    position: relative;
  }

  .profile-img {
    height: 100px;
    width: 100px;
    object-fit: cover;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
  }

  .edit {
    background: var(--color-surface);
    height: 32px;
    width: 32px;
    border-radius: 50%;
    padding: 6px;
    color: var(--color-text);
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: -5px;
    right: 0;
    z-index: 3;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    border: 1px solid var(--color-border);

    &:hover {
      background-color: var(--color-background);
    }
  }

  .profile-img-input {
    height: 100px;
    width: 100px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    cursor: pointer;
    z-index: 4;
    border-radius: 50%;
  }
`;
